import { React, useState } from 'react';
import image01 from '../assets/img/about/about_history_01.png';
import image02 from '../assets/img/about/about_history_02.png';
import image03 from '../assets/img/about/about_history_03.png';
import '../css/AboutUs.css';

const History = () => {
    const historyText01 = 'Lorem ipsum odor amet, consectetuer adipiscing elit. Curabitur eros quis neque quisque; porta malesuada varius est. Ex vehicula taciti nulla per vivamus at potenti dapibus. Primis duis hac convallis nec bibendum vel venenatis parturient. Sodales pulvinar per nam nam dui, facilisi ipsum ex fames. Cursus aliquet fringilla tempor vel sociosqu turpis praesent varius.';
    const historyText02 = 'Dis duis rutrum diam egestas integer molestie vel suspendisse. Magna suscipit gravida ligula tristique habitasse egestas potenti taciti. Sagittis maecenas integer, nostra ipsum euismod odio rutrum aptent. Sociosqu eget aliquet donec enim integer auctor ex diam hac. Sollicitudin rhoncus magna dignissim per dapibus varius. Proin quis malesuada sit; semper dictum purus vestibulum.';
    
    const images = [image01, image03, image01, image03];
    const imagesLength = images.length;

    const [index01, setIndex01] = useState(0);
    const [index02, setIndex02] = useState(1);
    const [index03, setIndex03] = useState(2);

    const [carouselImage01, setCarouselImage01] = useState(images[0]);
    const [carouselImage02, setCarouselImage02] = useState(images[1]);
    const [carouselImage03, setCarouselImage03] = useState(images[2]);

    function previousHelper(index, setIndex){
        if(index === 0){
            setIndex(imagesLength-1);
            return imagesLength-1;    
        }
        setIndex(index-1);
        return index-1;
    }

    function handleCarouselPrevious(){
        setCarouselImage01(images[previousHelper(index01, setIndex01)]);
        setCarouselImage02(images[previousHelper(index02, setIndex02)]);
        setCarouselImage03(images[previousHelper(index03, setIndex03)]);
    }

    function nextHelper(index, setIndex){
        if(index === imagesLength-1){
            setIndex(0);
            return 0;    
        }
        setIndex(index+1);
        return index+1;
    }

    function handleCarouselNext(){
        setCarouselImage01(images[nextHelper(index01, setIndex01)]);
        setCarouselImage02(images[nextHelper(index02, setIndex02)]);
        setCarouselImage03(images[nextHelper(index03, setIndex03)]);
    }

    return (
        <div className='history-container'>
            <div className='section-container header image'>
                <div className='about-us-text-container palanquin-dark flex-center'>
                    <div className='history-heading primary-yellow-text bold'>HISTORY</div>
                    <div className='history-subheading secondary-white-text regular'>St. Therese of the Child Jesus Multiple Intelligence School</div>
                </div>
            </div>
            <div className='section-container'>
                <div className='upper-pane flex-center'>
                    <div className='history-text secondary-white-text palanquin-dark regular'>
                        {historyText01}
                    </div>
                    <div className='history-text secondary-white-text palanquin-dark regular'>
                        {historyText02}
                    </div>
                </div>
                <div className='lower-pane flex-center'>
                    <div className='history-images'>
                        <img 
                            className=''
                            src={carouselImage01}
                            alt='stcjmis-history-01'
                        />
                        <img 
                            className=''
                            src={carouselImage02}
                            alt='stcjmis-history-02'
                        />
                        <img 
                            className=''
                            src={carouselImage03}
                            alt='stcjmis-history-03'
                        />
                    </div>
                </div>
                <div className='history-buttons-container flex-center'>
                        <div 
                            className='image history-arrow-left cursor-pointer'
                            onClick={() => handleCarouselPrevious()}
                        />
                        <div className='history-circle'/>
                        <div className='history-circle'/>
                        <div className='history-circle'/>
                        <div 
                            className='image history-arrow-right cursor-pointer'
                            onClick={() => handleCarouselNext()}
                        />
                    </div>
            </div>
        </div>
    );
};

export default History;
